import { Dtos, personDisplayName } from "@inrev/common";
import type { AuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";

export const followerFromAuthenticatedUser = (
	user: AuthenticatedUser,
): Dtos.Follower.Get.Response => ({
	id: user.id,
	email: user.email,
	type: user.type,
	setupComplete: user.setupComplete,
	displayName: personDisplayName({
		firstName: user.firstName,
		lastName: user.lastName,
		email: user.email,
	}),
});
